export const URL_PARAMS = {
  activeStation: 'active-station',
  specialEvent: 'specialEventId',
  hasEvents: 'hasEvents',
  favoriteCatalogs: 'favoriteCatalogs',
  fuelCardnumber: 'numberCard',
} as const;
